<template>
    <div class="page-404">
        <div class="container">
            <div class="page-404__description">
                <template v-if="!!slots.description">
                    <slot name="description" v-if="!!slots.description"></slot>
                </template>
                <template v-else>
                    <div class="page-404__title" v-html="text.title"></div>
                    <p class="page-404__text"><vue-raw :raw="text.description" /></p>
                </template>
            </div>
        </div>
    </div>
</template>

<script setup>
import { localize } from '@/utils/i18n'
import {useSlots} from 'vue'

const props = defineProps({
    hideImage: {
        type: Boolean
    }
})

const image = '/images/not-found/not-found.png'
const text = {
    title: localize({
        ru: 'Мы&nbsp;не&nbsp;смогли найти<br>страницу, которую<br>вы&nbsp;ищете',
        en: 'We&nbsp;couldn&rsquo;t find <br> the page <br>you are looking for.',
        cn: '页面未找到'
    }),
    description: localize({
        ru: 'Если вы&nbsp;ввели URL вручную, проверьте правильность написания и&nbsp;повторите попытку. Или вы&nbsp;можете вернуться на&nbsp;<z-link href="/">главную страницу.',
        en: 'If you manually entered the URL, please check the spelling and try again. Alternatively, you can return to the <z-link href="/">homepage</z-link>.',
        cn: '如果您手动输入了统一资源定位器(URL)，请检查拼写并重试。或者，您可以返回<z-link href="/">首页</z-link>。'
    })
}

const slots = useSlots()

defineExpose({
    props
})
</script>

<style lang="scss">
.page-404 {
    display: flex;
    background-image: url(/media/img/sunrise.png);
    background-repeat: no-repeat;
    background-size: cover;
    background-position: bottom;
    aspect-ratio: 1920/1034;
    // padding-left: 120px;
    // padding-right: 120px;
    padding-top: 52px;

    @include breakpoint (laptop) {
        font-size: 48px;
        // padding-left: 96px;
        // padding-right: 96px;
    }

    @include breakpoint (tablet) {
        // padding-left: 48px;
        // padding-right: 48px;
        aspect-ratio: unset;
        padding-bottom: 240px;
    }

    @include breakpoint (mobile) {
        font-size: 26px;
        // padding-left: 28px;
        // padding-right: 28px;
    }

    &__image {
        flex-shrink: 0;
        margin-right: var(--spacer-2xs);

        @include breakpoint (mobile) {
            margin-right: 0;
            margin-bottom: var(--spacer-xs);
        }
    }

    &__title {
        display: block;
        font-size: 80px;
        font-weight: 500;
        color: var(--color-white);
        @include margin-level(bottom, XS);
        line-height: 1.1;

        @include breakpoint (laptop) {
            font-size: 48px;
        }

        @include breakpoint (mobile) {
            font-size: 26px;
        }
    }

    &__text {
        font-size: 30px;
        line-height: 1.4;
        color: var(--color-white);
        margin-bottom: 0;
        max-width: 1020px;

        @include breakpoint (laptop) {
            font-size: 24px;
        }

        @include breakpoint (mobile) {
            font-size: 16px;
        }
    }

    &__description {
        .z-link {
            color: var(--color-white);
        }
    }
}
</style>
